// @flow
import * as React from 'react';
import { useTheme } from '@mui/material';

/**
 * PEP Checkmark svg
 *
 * @param props
 * @return {XML}
 */
const PepCheckmark = (props) => {
  const theme = useTheme();
  const { width = 28, height = 28, color = theme.palette.purple.main, style, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...rest}
    >
      <circle
        cx="16"
        cy="16"
        r="14"
        stroke={color}
        strokeWidth="2"
        fill="transparent"
      />
      <path
        d="M9 16L15 22L23 10"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PepCheckmark;
